import axios from "@/utils/axios";

const API_URL = process.env.VUE_APP_API_URL || "";

export const getCompanyData = async () => {
  const response = await axios.get(`${API_URL}/societe`);
  return response.data;
};

export const createCompany = async (data) => {
  const response = await axios.post(`${API_URL}/societe`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};


export const updateCompany = async (data) => {
  // Determine if data is FormData (has files) or regular object
  const isFormData = data instanceof FormData;
  
  const config = {};
  
  if (isFormData) {
    // Add _method field to simulate PUT request
    data.append('_method', 'PUT');
    
    // For FormData (when uploading files) - use POST with _method override
    config.headers = {
      "Content-Type": "multipart/form-data",
    };
    
    // Use POST instead of PUT for FormData
    const response = await axios.post(`${API_URL}/societe`, data, config);
    return response.data;
    
  } else {
    // For regular JSON data - use PUT
    config.headers = {
      "Content-Type": "application/json",
    };
    
    const response = await axios.put(`${API_URL}/societe`, data, config);
    return response.data;
  }
};

// Fetch company logo data (base64/data URL) for embedding in PDFs
export const getCompanyLogoData = async (type = 'logo') => {
  const response = await axios.get(`${API_URL}/societe/logo`, {
    params: { type },
  });
  return response.data && response.data.data ? response.data.data : null;
};

// Direct image endpoint that returns binary; convert to data URL for embedding
export const getCompanyLogoDataUrl = async (type = 'logo') => {
  const response = await axios.get(`${API_URL}/societe/logo/image`, {
    params: { type },
    responseType: 'arraybuffer',
  });
  const contentType = response.headers['content-type'] || 'image/png';
  const bytes = new Uint8Array(response.data);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  const base64 = btoa(binary);
  return `data:${contentType};base64,${base64}`;
};
